import reduxConnector from 'root/src/shared/util/reduxConnector'

import linkTargetSelector from 'root/src/client/logic/app/selectors/linkTargetSelector'
import linkHrefSelector from 'root/src/client/logic/app/selectors/linkHrefSelector'

import setPreferredPlatform from 'root/src/client/logic/static/thunks/setPreferredPlatform'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import handleAuthenticationRouting from 'root/src/client/logic/route/thunks/handleAuthenticationRouting'
import { clearRoute } from 'root/src/client/logic/route/thunks/clearRoute'

export default reduxConnector(
	[
		['linkHref', linkHrefSelector],
		['linkTarget', linkTargetSelector],
	],
	[
		['clearRoute', clearRoute],
		['setPreferredPlatform', setPreferredPlatform],
		['displayModal', displayModal],
		['handleAuthenticationRouting', handleAuthenticationRouting],
	],
)
